/** Tous les reducers de l'application
 * @module
 */

export groomers from './../groomers/reducer';
export user from './../user/reducer';
export planning from './../planning/reducer';
export users from './../users/reducer';
export updates from '../updates/reducer';



// WEBPACK FOOTER //
// ./src/redux/_commons/reducers.js